const baseUrl="https://www.bipuqd.com"
export const url=baseUrl+'/server-api/APP/'
export const webUrl=baseUrl

// export const url="http://121.37.81.3:8000/APP/"
// export const webUrl="http://121.37.81.3:8000/APP/"

// export const url="http://192.168.4.119:8000/APP/"
// export const webUrl="http://192.168.4.119:8000/APP/"

// const baseUrl="api"
// export const url=baseUrl+'/b2-test/APP/'
// export const webUrl=baseUrl



// WEBPACK FOOTER //
// ./src/api/url.js